import React, { useState, useEffect, useCallback } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { NavLink } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import Examination_navbar from "./Examination_navbar";
import ShowExam from "../Shared/ShowExam";
import SessionsDropDown from "../Shared/SessionsDropDown";
import WingsDropDown from "../Shared/WingsDropDown";
import Pagination from "../General/Pagination";

function ExamClasses() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(true);
  const [listOfLedger, setLedger] = useState([]);
  const [loadingItem, setLoadingItem] = useState(null);
  const [examReadOnly, setExamReadOnly] = useState(false);

  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [WingId, setWingId] = useState("0");
  const [SessionId, setSessionId] = useState(
    localStorage.getItem("DefaultSession") || "0"
  );

  const params = useParams();
  const examId = parseInt(params.id, 10) || 0;

  const handleExamLoaded = useCallback((exam) => {
    const status = (exam.Current_Status || "").toString().toLowerCase();
    setExamReadOnly(status === "closed");
    setSessionId((current) => {
      if (!current || current === "0") {
        return String(exam.Session_ID || 0);
      }
      return current;
    });
  }, []);

  const fetchClasses = useCallback(() => {
    if (examId <= 0) {
      setLoading(false);
      setLedger([]);
      return;
    }

    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: pageNo,
      pageSize: pageSize,
      ExamID: examId,
      SessionID: parseInt(SessionId, 10) || 0,
      Wing_Id: parseInt(WingId, 10) || 0,
    };

    const api_config = {
      method: "post",
      url: config.base_url + "Exam/GetExamClasses",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        setLoading(false);
        if (response.data.status_code === 1) {
          setLedger(response.data.ListofRecords || []);
          setTotalRecords(response.data.totalRecords || 0);
        } else {
          setLedger([]);
          setTotalRecords(0);
          if (response.data.status_message) {
            toast.info(response.data.status_message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        }
      })
      .catch(function () {
        setLoading(false);
        setLedger([]);
        setTotalRecords(0);
        toast.error("Unable to load exam classes. Please try again.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }, [
    AccessKey,
    UserID,
    MemberType,
    pageNo,
    pageSize,
    examId,
    SessionId,
    WingId,
  ]);

  useEffect(() => {
    document.title = "Manage Exam Classes";
    fetchClasses();
  }, [fetchClasses]);

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const handleSessionChange = (e) => {
    setSessionId(e.target.value);
    setPageNo(1);
  };

  const handleWingChange = (e) => {
    setWingId(e.target.value);
    setPageNo(1);
  };

  const handlePageSizeChange = (e) => {
    setPageSize(parseInt(e.target.value, 10) || 10);
    setPageNo(1);
  };

  const setClassSelected = (classId, isSelected) => {
    setLedger((prev) =>
      prev.map((item) =>
        item.Class_Id === classId ? { ...item, IsSelected: isSelected } : item
      )
    );
  };

  const UpdateClass = (e, classId) => {
    e.preventDefault();
    if (examReadOnly) {
      toast.warning("This exam is closed. Classes cannot be changed.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    const newChecked = e.target.checked;
    const previousChecked = !newChecked;
    setLoadingItem(classId);
    setClassSelected(classId, newChecked);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      Class_Id: classId,
      ExamID: examId,
      hasRights: newChecked,
    };

    const api_config = {
      method: "post",
      url: config.base_url + "Exam/AddRemoveClassInExam",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        setLoadingItem(null);
        const code = response.data?.status_code;
        const message = response.data?.status_message || "Request failed.";

        if (code === 1) {
          toast.success(message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          return;
        }

        setClassSelected(classId, previousChecked);
        if (code === 0) {
          toast.warning(message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.error(message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(function () {
        setLoadingItem(null);
        setClassSelected(classId, previousChecked);
        toast.error("Unable to update class. Please try again.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const renderLedger = () => {
    if (listOfLedger != null && listOfLedger.length > 0) {
      let count = 1;
      return listOfLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>{count++ + pageSize * (pageNo - 1)}</td>
            <td>{item.Class_Id}</td>
            <td>{item.Class_Code}</td>
            <td>{item.Class_Short_Name}</td>
            <td>{item.Class_Name}</td>
            <td>{item.Wing_Name}</td>
            <td>{item.Session_Name}</td>
            <td>
              {loadingItem === item.Class_Id ? (
                <Spinner animation="grow" size="sm" />
              ) : (
                <div className="form-check">
                  <input
                    className="form-check-input"
                    checked={!!item.IsSelected}
                    type="checkbox"
                    disabled={examReadOnly}
                    onChange={(e) => UpdateClass(e, item.Class_Id)}
                  />
                </div>
              )}
            </td>
          </tr>
        );
      });
    }

    if (!loading) {
      return (
        <tr>
          <td colSpan="8">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }

    return null;
  };

  return (
    <>
      <ToastContainer />

      <Examination_navbar />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/ExaminationSystem/ExaminationDashboard">
                        Examinations
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Manage Exam Classes
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Manage Exam Classes</div>
              </div>
            </div>
          </div>
        </div>

        <div className="collapse show" id="collapseFilteres">
          <div className="page-content">
            <div className="container">
              <ShowExam ExamID={examId} onExamLoaded={handleExamLoaded} />
              {examReadOnly && (
                <div className="alert alert-warning py-2 mb-2" role="alert">
                  This exam is closed. Class selection is read-only.
                </div>
              )}
              <div className="card mb-2">
                <div className="card-body">
                  <div className="row align-items-end gy-3">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label className="">Select Session:</label>
                        <select
                          className="form-select"
                          value={SessionId}
                          onChange={handleSessionChange}
                          name="SessionID"
                        >
                          <option value="0">---Exam session---</option>
                          <SessionsDropDown selectedSession={SessionId} />
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Select Wing:</label>
                        <select
                          name="WingId"
                          value={WingId}
                          onChange={handleWingChange}
                          className="form-select"
                        >
                          <option value="0">---All---</option>
                          <WingsDropDown />
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6 text-md-end">
                      <span className="text-muted small">
                        {totalRecords > 0
                          ? `${totalRecords} class(es) found`
                          : loading
                          ? "Loading classes..."
                          : "No classes to display"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card mt-2">
                <div className="card-body">
                  <table className="table table-theme table-hover">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Class ID</th>
                        <th>Class Code</th>
                        <th>Class Short Name</th>
                        <th>Class Name</th>
                        <th>Wing Name</th>
                        <th>Session</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td className="text-center" colSpan="8">
                            <Spinner animation="border" role="status"></Spinner>
                          </td>
                        </tr>
                      ) : (
                        <>{renderLedger()}</>
                      )}
                    </tbody>
                  </table>

                  {totalRecords > pageSize && (
                    <div className="pagination-wrap mt-3">
                      <div className="row align-items-center">
                        <div className="col-md-2 form_default">
                          <div className="d-flex align-items-center">
                            <label className="me-2" style={{ fontSize: "15px" }}>
                              Page Size
                            </label>
                            <div className="form-group">
                              <select
                                className="form-select"
                                style={{ width: "100px" }}
                                value={pageSize}
                                onChange={handlePageSizeChange}
                              >
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <Pagination
                          pageNo={pageNo}
                          pageSize={pageSize}
                          totalRecords={totalRecords}
                          onPageChange={handlePageChange}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExamClasses;
